import React from "react";

function About() {
  return (
    <div className="section">
      <h2 className="underline" id="About">About me</h2>
      <div className="inner-section scroll-bar">
        <p><span className="welcome">Welcome,</span></p>
        <p>I’m a Junior Web Developer with a background in Economics. This is my site, where I share my side projects that I’ve been working on. Please have a look and feel free to reach out regarding any opportunities.</p>
        <p>I joined the Software Engineering Immersive program at General Assembly to solidify my ability and continue my career as a Junior Developer.</p>
        <p>I build mostly front-end websites with a focus on responsiveness, accessibility and pleasing aesthetics. My interest in coding was sparked during the pandemic when I realised the importance of the applications we use daily to stay connected. </p>
        <p>When I’m not coding, you can find me trying new food recipes, watering my plants, playing with my cats or even occasionally at the gym.</p>
      </div>
    </div>
  )
}
export default About